import { useState, ReactNode } from 'react'
import { SlidersHorizontal } from 'lucide-react'
import Tooltip from 'antd/es/tooltip';

type FilterButtonProps = {
  handleClick: () => void;
  Icon: ReactNode;
  title: string;
  classNames?: string;
  titleClassName?: string
  tooltip?: string
}

export function ActionButton({ handleClick, Icon, title, classNames, titleClassName, tooltip }: FilterButtonProps) {
  const [isActiveFilter, setIsActiveFilter] = useState(false);

  const handlClickFilter = () => {
    setIsActiveFilter(!isActiveFilter)
    handleClick()
  }

  const buttonContent = (
    <div className={`flex items-center h-[40px] rounded px-3 cursor-pointer text-base bg-[#e3e3e3] shrink-0 whitespace-nowrap ${classNames}`} onClick={handlClickFilter}>
      {Icon}
      <span className={`ml-2 text-sm ${titleClassName}`}>{title}</span>
    </div>
  );

  return tooltip ? (
    <Tooltip title={tooltip}>
      {buttonContent}
    </Tooltip>
  ) : (
    buttonContent
  );
}